(function () {
  'use strict';

  // Gracefully no-op if View Transitions API is not supported
  if (!document.startViewTransition) return;

  // ── Inject transition CSS ─────────────────────────────────────────────────
  const style = document.createElement('style');
  style.textContent = `
    @keyframes fade-slide-out {
      from { opacity: 1; transform: translateY(0); }
      to   { opacity: 0; transform: translateY(-12px); }
    }

    @keyframes fade-slide-in {
      from { opacity: 0; transform: translateY(12px); }
      to   { opacity: 1; transform: translateY(0); }
    }

    ::view-transition-old(root) {
      animation: fade-slide-out 300ms var(--ease-out, ease-out) both;
    }

    ::view-transition-new(root) {
      animation: fade-slide-in 300ms var(--ease-out, ease-out) both;
    }
  `;
  document.head.appendChild(style);

  // ── Link click interception ───────────────────────────────────────────────
  document.addEventListener('click', function (e) {
    const anchor = e.target.closest('a');
    if (!anchor) return;

    const href = anchor.getAttribute('href');
    if (!href) return;

    // Skip: external links
    if (anchor.hostname && anchor.hostname !== window.location.hostname) return;

    // Skip: new tab / new window
    if (anchor.target === '_blank') return;

    // Skip: hash-only navigation
    if (href.startsWith('#')) return;

    // Skip: download links
    if (anchor.hasAttribute('download')) return;

    // Skip: mailto / tel / javascript
    if (/^(mailto:|tel:|javascript:)/i.test(href)) return;

    // Skip: data-no-transition attribute
    if (anchor.hasAttribute('data-no-transition')) return;

    // Skip: modifier keys (open in new tab, etc.)
    if (e.ctrlKey || e.metaKey || e.shiftKey || e.altKey) return;

    e.preventDefault();

    const targetUrl = anchor.href;

    document.startViewTransition(function () {
      window.location.assign(targetUrl);

      // Return a promise that resolves when navigation is done.
      // The browser handles the actual page load; this resolves immediately
      // to let startViewTransition capture the new state.
      return new Promise(function (resolve) {
        window.addEventListener('pageshow', resolve, { once: true });
      });
    });
  });

  // ── Restore scroll position after transition ──────────────────────────────
  window.addEventListener('pageshow', function () {
    // On back/forward navigation, restore natural scroll
    if (performance.navigation && performance.navigation.type === 2) {
      // Back/forward — browser handles scroll restoration
      return;
    }
    // On fresh navigation, scroll to top
    window.scrollTo({ top: 0, behavior: 'instant' });
  });
})();
